export const ROTA_COMPRAS = "/admin/compras";
export const ROTA_NOVA_COMPRA = "/admin/compras/nova";
export const rotaEditarCompra = (loteId) => `/admin/compras/${encodeURIComponent(loteId)}/editar`;
